"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TAG = exports.SIZE = exports.ICON_TYPE = exports.FLEX_PROPERTIES = exports.COLOR = void 0;
var TRANSLATION = {
  bookingNumberMobile: 'Booking no.',
  general: 'general'
};
exports.TRANSLATION = TRANSLATION;
var ICON_TYPE = {
  small: {
    size: 'normal'
  },
  normal: {
    color: 'greyDark',
    size: 'titleNormal'
  },
  large: {
    size: 'large'
  }
};
exports.ICON_TYPE = ICON_TYPE;
var FLEX_PROPERTIES = {
  inlineFlex: 'inlineFlex',
  start: 'start'
};
exports.FLEX_PROPERTIES = FLEX_PROPERTIES;
var TAG = {
  p: 'p',
  div: 'div'
};
exports.TAG = TAG;
var SIZE = {
  medium: 'medium',
  default: 'default',
  titleNormal: 'titleNormal',
  textSmall: 'textSmall',
  small: 'small',
  micro: 'micro'
};
exports.SIZE = SIZE;
var COLOR = {
  green: 'green',
  greenLight: 'greenLight',
  greyDark: 'greyDark',
  greyDarker: 'greyDarker',
  tertiary: 'tertiary',
  neutral: 'neutral'
};
exports.COLOR = COLOR;